import { StandardPaginationLabels } from '@brandfolder/react';

export const getStandardPaginationLabels = (labels: Partial<StandardPaginationLabels> = {}): StandardPaginationLabels => {
  return {
    nextLabel: bfTranslate('Next'),
    previousLabel: bfTranslate('Previous'),
    ...labels
  };
};
